/**
 * ECharts implementations of the Chart interface.
 *
 * Bar + Pie/Donut land Week 2. ECharts is the leading candidate for the
 * geo-map widget (built-in series: 'map' + scatter overlay) — geo lands
 * Week 4 alongside Visx + D3 implementations for honest comparison.
 */

import type { FullChartProps } from '../types';
import { EchartsBar } from './Bar';
import { EchartsPie } from './Pie';

export function renderEchartsChart(props: FullChartProps): JSX.Element {
  switch (props.type) {
    case 'bar':
      return <EchartsBar {...props} />;
    case 'pie':
    case 'donut':
      return <EchartsPie {...props} />;
    default:
      throw new Error(
        `ECharts implementation for chart type '${props.type}' not yet wired. Land in Week 3 (line/area/stacked) or Week 4 (geo/sparkline-table/kpi).`
      );
  }
}
